import React from 'react'
import { Col, Dropdown, Label, Row, RoomSearchSelect, SelectOption, Text, ToggleSwitch } from '@evertel/web/ui'
import { APIDataRoom } from '@evertel/types'
import { roles as roleOptions } from '@evertel/constants'

interface AgreementSettingsFieldsProps {
    departmentId: number
    idPrefix: string
    roles: SelectOption[]
    onRolesChange: (roles: SelectOption[]) => void
    rooms: APIDataRoom[]
    onRoomsChange: (rooms: APIDataRoom[]) => void
    acceptOncePerRoom: boolean
    onAcceptOncePerRoomChange: (checked: boolean) => void
    enabled: boolean
    onEnabledChange: (checked: boolean) => void
}

const AgreementSettingsFields: React.FC<AgreementSettingsFieldsProps> = ({
    departmentId,
    idPrefix,
    roles,
    onRolesChange,
    rooms,
    onRoomsChange,
    acceptOncePerRoom,
    onAcceptOncePerRoomChange,
    enabled,
    onEnabledChange
}) => (
    <>
        <Text bold className="d-block mb-3">Settings</Text>
        <Label
            text="Restrict to selected roles"
            optional
            htmlFor={`${idPrefix}-roles`}
        />
        <Dropdown
            id={`${idPrefix}-roles`}
            options={roleOptions}
            value={roles.map(r => r.value as string)}
            onChange={(val) => onRolesChange(val as SelectOption[])}
            isMulti
            placeholder="Select roles"
            className="mb-1"
        />
        <small className="text-muted d-block mb-3">Leave blank to include all roles</small>

        <Label
            text="Restrict to selected rooms"
            optional
            htmlFor={`${idPrefix}-rooms`}
        />
        <RoomSearchSelect
            id={`${idPrefix}-rooms`}
            departmentId={departmentId}
            searchScope="department"
            isMulti
            placeholder="Select rooms"
            className="mb-1"
            selected={rooms}
            onSelect={(val) => onRoomsChange(val)}
        />
        <small className="text-muted d-block mb-3">Leave blank to include all rooms</small>

        <Row valign="center" className="mb-4">
            <ToggleSwitch
                checked={acceptOncePerRoom}
                onChange={onAcceptOncePerRoomChange}
                optionLabels={['On', 'Off']}
            />
            <div className="ms-2">
                <Text bold className="d-block">Accept once per room</Text>
                <Text color="muted" style={{ fontSize: '0.85rem' }}>
                    Users must accept the agreement each time they enter a room for the first time.
                </Text>
            </div>
        </Row>

        <Text bold className="d-block mb-3">Status</Text>
        <div className="border rounded p-3">
            <Row valign="center" align="between">
                <Col>
                    <Text bold className="d-block">Activate Agreement</Text>
                    <small className="text-muted">
                        When active, users matching the configuration of the agreement will be prompted on their next room entry.
                    </small>
                </Col>
                <Col xs="auto">
                    <ToggleSwitch
                        checked={enabled}
                        onChange={onEnabledChange}
                        optionLabels={['On', 'Off']}
                    />
                </Col>
            </Row>
        </div>
    </>
)

AgreementSettingsFields.displayName = 'AgreementSettingsFields'
export { AgreementSettingsFields }
